import { ArrowDown, ArrowUp } from 'lucide-react'
import PropTypes from 'prop-types'

import { AdasButton } from '@components/wrapper-components'

export const SortIndicator = ({ direction = 'ASC' }) => {
  return (
    <AdasButton buttonType='iconButton' size='small' className='ml-2'>
      {direction === 'ASC' ? <ArrowUp className='w-4 h-4' /> : <ArrowDown className='w-4 h-4' />}
    </AdasButton>
  )
}

SortIndicator.propTypes = {
  direction: PropTypes.oneOf(['ASC', 'DESC'])
}
